import React from "react";
import Skill from "../skill/Skill";
import Projects from "../projects/Projects";

export default function Description() {
  return (
    <>
      <Skill />
      <Projects />
    </>
  );
}
